import React from 'react';
import { Search } from 'lucide-react';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const ForumSearchBar: React.FC<Props> = ({
  value,
  onChange,
  placeholder = 'Konu başlığı veya içerikte ara…',
}) => (
  <div className="forum-search-bar">
    <Search size={18} className="forum-search-bar__icon" />
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label="Forum arama"
    />
  </div>
);

export default ForumSearchBar;
